export default __webpack_public_path__ + "static/media/white-color-palette.7a113f86.png";